import * as React from "react";
import type { SVGProps } from "react";
const SvgIconFirefox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 76 75"
    {...props}
  >
    <path
      fill="url(#Icon_firefox_svg__a)"
      d="M68.151 25.131c-1.427-3.443-4.32-7.16-6.59-8.334 1.848 3.632 2.917 7.275 3.325 9.994q-.002 0 .007.055C61.18 17.564 54.88 13.82 49.734 5.673a35 35 0 0 1-.775-1.262 10 10 0 0 1-.36-.685 6 6 0 0 1-.491-1.298.09.09 0 0 0-.074-.089.1.1 0 0 0-.062 0l-.015.01c-.008 0-.016.01-.025.012l.014-.018c-8.253 4.845-11.053 13.807-11.31 18.292a16.4 16.4 0 0 0-9.05 3.492 10 10 0 0 0-.85-.644 15.3 15.3 0 0 1-.091-8.048c-3.376 1.541-6 3.973-7.91 6.126h-.014c-1.303-1.654-1.212-7.108-1.138-8.247-.015-.071-.97.497-1.093.584a24 24 0 0 0-3.212 2.756 29 29 0 0 0-3.068 3.687 27.8 27.8 0 0 0-4.409 9.978q-.021.108-.044.218c-.061.289-.284 1.74-.324 2.055v.072c-.29 1.5-.471 3.018-.54 4.544v.168c0 18.185 14.71 32.928 32.854 32.928 16.252 0 29.744-11.825 32.386-27.357.055-.42.1-.845.15-1.27.653-5.648-.073-11.583-2.132-16.546m-37.87 25.776c.153.072.298.153.456.224l.021.014a22 22 0 0 1-.475-.239zM64.896 26.86v-.032.036z"
    />
    <path
      fill="url(#Icon_firefox_svg__b)"
      d="M68.151 25.132c-1.427-3.444-4.32-7.16-6.59-8.335 1.847 3.632 2.917 7.275 3.325 9.994v.067c3.101 8.424 1.411 16.99-1.022 22.224-3.765 8.097-12.88 16.397-27.149 15.993-15.404-.438-28.983-11.908-31.52-26.918-.462-2.369 0-3.57.233-5.492-.283 1.48-.391 1.91-.532 4.543v.168c0 18.185 14.71 32.928 32.855 32.928 16.252 0 29.744-11.825 32.387-27.357.054-.42.1-.845.149-1.27.649-5.647-.077-11.583-2.136-16.545"
    />
    <path
      fill="url(#Icon_firefox_svg__c)"
      d="M68.151 25.132c-1.427-3.444-4.32-7.16-6.59-8.335 1.847 3.632 2.917 7.275 3.325 9.994v.067c3.101 8.424 1.411 16.99-1.022 22.224-3.765 8.097-12.88 16.397-27.149 15.993-15.404-.438-28.983-11.908-31.52-26.918-.462-2.369 0-3.57.233-5.492-.283 1.48-.391 1.91-.532 4.543v.168c0 18.185 14.71 32.928 32.855 32.928 16.252 0 29.744-11.825 32.387-27.357.054-.42.1-.845.149-1.27.649-5.647-.077-11.583-2.136-16.545"
    />
    <path
      fill="url(#Icon_firefox_svg__d)"
      d="M52.184 29.001c.073.051.137.102.206.152a17.9 17.9 0 0 0-3.052-3.99C39.126 14.93 46.661 2.97 47.931 2.363l.014-.018C39.69 7.189 36.892 16.15 36.635 20.635c.382-.026.764-.059 1.153-.059 6.16 0 11.524 3.395 14.396 8.425"
    />
    <path
      fill="url(#Icon_firefox_svg__e)"
      d="M37.809 31.045c-.053.822-2.94 3.644-3.951 3.644-9.343 0-10.86 5.664-10.86 5.664.41 4.771 3.727 8.7 7.74 10.778q.277.14.547.264c.321.137.644.274.965.396 1.376.487 2.817.764 4.275.823 16.376.77 19.55-19.624 7.731-25.545 3.026-.528 6.167.693 7.922 1.927-2.871-5.03-8.237-8.425-14.396-8.425-.39 0-.771.033-1.154.06a16.4 16.4 0 0 0-9.041 3.496c.502.426 1.067.993 2.258 2.169 2.234 2.208 7.952 4.482 7.964 4.749"
    />
    <path
      fill="url(#Icon_firefox_svg__f)"
      d="M37.809 31.045c-.053.822-2.94 3.644-3.951 3.644-9.343 0-10.86 5.664-10.86 5.664.41 4.771 3.727 8.7 7.74 10.778q.277.14.547.264c.321.137.644.274.965.396 1.376.487 2.817.764 4.275.823 16.376.77 19.55-19.624 7.731-25.545 3.026-.528 6.167.693 7.922 1.927-2.871-5.03-8.237-8.425-14.396-8.425-.39 0-.771.033-1.154.06a16.4 16.4 0 0 0-9.041 3.496c.502.426 1.067.993 2.258 2.169 2.234 2.208 7.952 4.482 7.964 4.749"
    />
    <path
      fill="url(#Icon_firefox_svg__g)"
      d="M26.06 23.032c.266.173.485.318.683.45a15.3 15.3 0 0 1-.091-8.047c-3.376 1.541-6 3.973-7.91 6.126.155-.005 4.92-.09 7.317 1.471"
    />
    <path
      fill="url(#Icon_firefox_svg__h)"
      d="M5.196 38.158c2.536 15.01 16.116 26.48 31.53 26.918 14.27.404 23.379-7.896 27.15-15.994 2.433-5.235 4.123-13.8 1.022-22.224v-.063c0 .008 0 .02.007.055 1.165 7.628-2.706 15.017-8.757 20.014l-.017.042c-11.792 9.623-23.075 5.805-25.36 4.248a19 19 0 0 1-.477-.239c-6.875-3.288-9.715-9.57-9.106-14.954-5.804 0-7.783-4.907-7.783-4.907s5.211-3.724 12.08-.485c6.361 3 12.336.486 12.336.485-.013-.268-5.73-2.547-7.96-4.75-1.19-1.175-1.757-1.742-2.259-2.168a10 10 0 0 0-.85-.644c-.195-.137-.41-.274-.683-.451-2.397-1.562-7.163-1.476-7.32-1.471h-.015c-1.303-1.654-1.212-7.109-1.138-8.247-.015-.072-.97.497-1.093.583a24 24 0 0 0-3.212 2.757 29 29 0 0 0-3.068 3.687 27.8 27.8 0 0 0-4.409 9.977c-.026.063-1.195 5.178-.618 7.83"
    />
    <path
      fill="url(#Icon_firefox_svg__i)"
      d="M49.338 25.163a17.9 17.9 0 0 1 3.051 3.99q.256.193.492.41c7.449 6.874 3.552 16.603 3.256 17.302 6.05-4.997 9.921-12.387 8.756-20.014C61.18 17.564 54.88 13.82 49.734 5.673c-.26-.411-.52-.822-.775-1.262a10 10 0 0 1-.36-.685 6 6 0 0 1-.491-1.298.09.09 0 0 0-.074-.089.1.1 0 0 0-.062 0l-.015.01c-.008 0-.016.01-.025.012-1.271.608-8.807 12.567 1.406 22.802"
    />
    <path
      fill="url(#Icon_firefox_svg__j)"
      d="M52.879 29.557a6 6 0 0 0-.492-.41l-.205-.153c-1.754-1.233-4.896-2.455-7.922-1.927 11.818 5.921 8.645 26.314-7.73 25.544a14.6 14.6 0 0 1-4.276-.822q-.483-.18-.965-.396a10 10 0 0 1-.547-.264l.022.014c2.284 1.562 13.567 5.379 25.36-4.248 0 0 .006-.018.017-.042.292-.687 4.189-10.416-3.262-17.296"
    />
    <path
      fill="url(#Icon_firefox_svg__k)"
      d="M22.998 40.354s1.517-5.664 10.86-5.664c1.01 0 3.897-2.825 3.95-3.645s-5.974 2.516-12.335-.485c-6.869-3.239-12.08.485-12.08.485s1.98 4.908 7.783 4.908c-.608 5.383 2.231 11.66 9.107 14.954.153.072.298.153.455.224-4.013-2.074-7.325-6.006-7.74-10.777"
    />
    <path
      fill="url(#Icon_firefox_svg__l)"
      d="M68.151 25.131c-1.427-3.443-4.32-7.16-6.59-8.334 1.848 3.632 2.917 7.275 3.325 9.994q-.002 0 .007.055C61.18 17.564 54.88 13.82 49.734 5.673a35 35 0 0 1-.775-1.262 10 10 0 0 1-.36-.685 6 6 0 0 1-.491-1.298.09.09 0 0 0-.074-.089.1.1 0 0 0-.062 0l-.015.01c-.008 0-.016.01-.025.012l.014-.018c-8.253 4.845-11.053 13.807-11.31 18.292.383-.026.764-.06 1.154-.06 6.159 0 11.523 3.396 14.396 8.426-1.754-1.233-4.896-2.456-7.922-1.928 11.818 5.922 8.645 26.315-7.73 25.545a14.6 14.6 0 0 1-4.276-.822 18 18 0 0 1-.965-.396 10 10 0 0 1-.547-.265l.022.014a20 20 0 0 1-.477-.238c.153.072.298.153.455.224-4.02-2.078-7.333-6.01-7.747-10.781 0 0 1.516-5.664 10.859-5.664 1.01 0 3.898-2.826 3.95-3.645-.011-.267-5.729-2.547-7.959-4.749-1.19-1.176-1.756-1.743-2.258-2.169a10 10 0 0 0-.85-.644 15.3 15.3 0 0 1-.092-8.048c-3.376 1.541-6 3.973-7.91 6.126h-.014c-1.303-1.654-1.211-7.108-1.138-8.247-.015-.071-.97.497-1.093.584a24 24 0 0 0-3.212 2.756 29 29 0 0 0-3.068 3.687 27.8 27.8 0 0 0-4.409 9.978l-.043.218c-.062.289-.34 1.76-.38 2.075 0-.023 0 .025 0 0a38 38 0 0 0-.49 4.596v.168c0 18.185 14.71 32.928 32.855 32.928 16.252 0 29.744-11.825 32.386-27.357.055-.42.1-.845.15-1.27.653-5.648-.073-11.583-2.132-16.546m-3.26 1.691v.036z"
    />
    <defs>
      <radialGradient
        id="Icon_firefox_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(68.4953 0 0 68.6456 61.281 9.879)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.13}
          stopColor="#FFBD4F"
        />
        <stop
          offset={0.19}
          stopColor="#FFAC31"
        />
        <stop
          offset={0.25}
          stopColor="#FF9D17"
        />
        <stop
          offset={0.28}
          stopColor="#FF980E"
        />
        <stop
          offset={0.4}
          stopColor="#FF563B"
        />
        <stop
          offset={0.47}
          stopColor="#FF3750"
        />
        <stop
          offset={0.71}
          stopColor="#F5156C"
        />
        <stop
          offset={0.78}
          stopColor="#EB0878"
        />
        <stop
          offset={0.86}
          stopColor="#E50080"
        />
      </radialGradient>
      <radialGradient
        id="Icon_firefox_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(68.4953 0 0 68.6456 36.253 37.942)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.3}
          stopColor="#960E18"
        />
        <stop
          offset={0.35}
          stopColor="#B11927"
          stopOpacity={0.74}
        />
        <stop
          offset={0.43}
          stopColor="#DB293D"
          stopOpacity={0.34}
        />
        <stop
          offset={0.5}
          stopColor="#F5334B"
          stopOpacity={0.09}
        />
        <stop
          offset={0.53}
          stopColor="#FF3750"
          stopOpacity={0}
        />
      </radialGradient>
      <radialGradient
        id="Icon_firefox_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(49.6218 0 0 49.7307 44.512 -5.699)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.13}
          stopColor="#FFF44F"
        />
        <stop
          offset={0.25}
          stopColor="#FFDC3E"
        />
        <stop
          offset={0.51}
          stopColor="#FF9D12"
        />
        <stop
          offset={0.53}
          stopColor="#FF980E"
        />
      </radialGradient>
      <radialGradient
        id="Icon_firefox_svg__e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(32.6132 0 0 32.6848 28.678 55.873)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.35}
          stopColor="#3A8EE6"
        />
        <stop
          offset={0.47}
          stopColor="#5C79F0"
        />
        <stop
          offset={0.67}
          stopColor="#9059FF"
        />
        <stop
          offset={1}
          stopColor="#C139E6"
        />
      </radialGradient>
      <radialGradient
        id="Icon_firefox_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-13.926 140.55 -137.551)scale(17.2808 20.3403)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.21}
          stopColor="#9059FF"
          stopOpacity={0}
        />
        <stop
          offset={0.28}
          stopColor="#8C4FF3"
          stopOpacity={0.06}
        />
        <stop
          offset={0.75}
          stopColor="#7716A8"
          stopOpacity={0.45}
        />
        <stop
          offset={0.97}
          stopColor="#6E008B"
          stopOpacity={0.6}
        />
      </radialGradient>
      <radialGradient
        id="Icon_firefox_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(23.4629 0 0 23.5144 35.388 7.07)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE226" />
        <stop
          offset={0.12}
          stopColor="#FFDB27"
        />
        <stop
          offset={0.3}
          stopColor="#FFC82A"
        />
        <stop
          offset={0.5}
          stopColor="#FFA930"
        />
        <stop
          offset={0.73}
          stopColor="#FF7E37"
        />
        <stop
          offset={0.79}
          stopColor="#FF7139"
        />
      </radialGradient>
      <radialGradient
        id="Icon_firefox_svg__h"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(100.104 0 0 100.323 53.831 -7.843)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.11}
          stopColor="#FFF44F"
        />
        <stop
          offset={0.46}
          stopColor="#FF980E"
        />
        <stop
          offset={0.62}
          stopColor="#FF5634"
        />
        <stop
          offset={0.72}
          stopColor="#FF3647"
        />
        <stop
          offset={0.9}
          stopColor="#E31587"
        />
      </radialGradient>
      <radialGradient
        id="Icon_firefox_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(7.3329 72.7555 -47.69815 4.8074 44.154 3.117)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF44F" />
        <stop
          offset={0.06}
          stopColor="#FFE847"
        />
        <stop
          offset={0.17}
          stopColor="#FFC830"
        />
        <stop
          offset={0.3}
          stopColor="#FF980E"
        />
        <stop
          offset={0.36}
          stopColor="#FF8B16"
        />
        <stop
          offset={0.45}
          stopColor="#FF672A"
        />
        <stop
          offset={0.57}
          stopColor="#FF3647"
        />
        <stop
          offset={0.74}
          stopColor="#E31587"
        />
      </radialGradient>
      <radialGradient
        id="Icon_firefox_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(62.4948 0 0 62.632 34.835 15.78)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.14}
          stopColor="#FFF44F"
        />
        <stop
          offset={0.48}
          stopColor="#FF980E"
        />
        <stop
          offset={0.59}
          stopColor="#FF5634"
        />
        <stop
          offset={0.66}
          stopColor="#FF3647"
        />
        <stop
          offset={0.9}
          stopColor="#E31587"
        />
      </radialGradient>
      <radialGradient
        id="Icon_firefox_svg__k"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(68.4009 0 0 68.551 51.332 19.445)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.09}
          stopColor="#FFF44F"
        />
        <stop
          offset={0.23}
          stopColor="#FFE141"
        />
        <stop
          offset={0.51}
          stopColor="#FFAF1E"
        />
        <stop
          offset={0.63}
          stopColor="#FF980E"
        />
      </radialGradient>
      <linearGradient
        id="Icon_firefox_svg__a"
        x1={63.802}
        x2={9.143}
        y1={12.864}
        y2={65.484}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.05}
          stopColor="#FFF44F"
        />
        <stop
          offset={0.11}
          stopColor="#FFE847"
        />
        <stop
          offset={0.22}
          stopColor="#FFC830"
        />
        <stop
          offset={0.37}
          stopColor="#FF980E"
        />
        <stop
          offset={0.4}
          stopColor="#FF8B16"
        />
        <stop
          offset={0.46}
          stopColor="#FF672A"
        />
        <stop
          offset={0.53}
          stopColor="#FF3647"
        />
        <stop
          offset={0.7}
          stopColor="#E31587"
        />
      </linearGradient>
      <linearGradient
        id="Icon_firefox_svg__l"
        x1={63.146}
        x2={16.635}
        y1={12.582}
        y2={58.993}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.17}
          stopColor="#FFF44F"
          stopOpacity={0.8}
        />
        <stop
          offset={0.27}
          stopColor="#FFF44F"
          stopOpacity={0.63}
        />
        <stop
          offset={0.49}
          stopColor="#FFF44F"
          stopOpacity={0.22}
        />
        <stop
          offset={0.6}
          stopColor="#FFF44F"
          stopOpacity={0}
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgIconFirefox;
